export const resolveTournamentOrganizerName = (tournament = {}) => [
  tournament.organizerName,
  tournament.createdBy?.name,
  tournament.createdByUser?.name,
  tournament.creator?.name,
].map((value) => String(value || '').trim()).find(Boolean) || '';

export const getTournamentOrganizerLabel = (tournament = {}) => {
  const organizerName = resolveTournamentOrganizerName(tournament);
  return organizerName ? `Organized by ${organizerName}` : '';
};
